import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import useGetDownloadTemplateData from "../../hooks/templateHooks/useGetDownloadTemplate";

export default function TrustOnlyOrFullDocumentModal({
  handleClose,
  trustType,
}: {
  handleClose: () => void;
  trustType: string;
}) {
  const { fetchDownloadTemplate } = useGetDownloadTemplateData();

  const [selectedDocumentType, setSelectedDocumentType] =
    useState<string>("");

  useEffect(() => {
    setSelectedDocumentType("");
  }, [trustType]);

  const handleDocumentTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    setSelectedDocumentType(value);
  };

  const handleSubmit = () => {
    if (selectedDocumentType) {
      fetchDownloadTemplate(selectedDocumentType);
      handleClose();
    } else {
      alert("Please select a Document Type");
    }
  };

  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title>Select Document Type</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3 d-flex flex-nowrap gap-3">
            <Form.Check
              inline
              className="text-nowrap"
              type="radio"
              label="Full Document"
              value={trustType}
              name="documentType"
              checked={selectedDocumentType === trustType}
              onChange={handleDocumentTypeChange}
            ></Form.Check>
            <Form.Check
              inline
              className="text-nowrap"
              type="radio"
              label="Trust Only"
              value={`${trustType} Trust Only`}
              name="documentType"
              checked={selectedDocumentType === `${trustType} Trust Only`}
              onChange={handleDocumentTypeChange}
            ></Form.Check>
          </Form.Group>
          <Button variant="primary" onClick={handleSubmit}>
            Download
          </Button>
        </Form>
      </Modal.Body>
    </>
  );
}
